import React, { useState, useEffect } from "react";
//bootstrap
import Carousel from 'react-bootstrap/Carousel';

// redux
import { useSelector } from "react-redux";
import { selectBookingSearch, selectTaskStatusFilter, selectTimelineData } from "_redux/slices/timeline/timeline-data";

// styling
import "./job-list.css"
import JobCard from "./job-card";
import { selectTimelineDate } from "_redux/slices/timeline/timeline-control";


const JobList = (props) => {

  const timelineData = useSelector(selectTimelineData);
  const bookingSearch = useSelector(selectBookingSearch);
  const timelineDate = useSelector(selectTimelineDate);                                 // select timeline Date
  const taskStatusFilter = useSelector(selectTaskStatusFilter);

  const [jobs, setJobs] = useState([]);
  const [activeSlide, setActiveSlide] = useState(0);                  // holds value of active slide
  const [touchScreen, setTouchScreen] = useState(false);

  useEffect(() => {
    let employeeId = props.employeeId;
    let hour = props.hour;
    let columnJobs = timelineData.columns[hour].jobs;
    let employeeJobs = columnJobs.filter((job) => job.employeeId == employeeId);

    if (Array.isFullArray(employeeJobs)) {
      employeeJobs = filterTasks(employeeJobs);
      const sortOrder = ["stopped", "completed"];

      const sortedArray = employeeJobs.sort((a, b) => {
        // Prioritize 'active'
        if (a.active && !b.active) return -1;
        if (!a.active && b.active) return 1;

        // Prioritize 'cancelled'
        if (a.cancelled && !b.cancelled) return -1;
        if (!a.cancelled && b.cancelled) return 1;

        // Check sortOrder for stopped and completed
        const aIndex = sortOrder.findIndex(key => a[key]);
        const bIndex = sortOrder.findIndex(key => b[key]);

        // Everything that is not active, stopped, completed, or cancelled comes before stopped/completed
        if (aIndex === -1 && bIndex !== -1) return -1;
        if (aIndex !== -1 && bIndex === -1) return 1;

        // If both match stopped or completed, use their order in sortOrder
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;

        // Maintain relative order for everything else
        return 0;
      });

      if (Array.isFullArray(sortedArray)) {
        setJobs(sortedArray);
      } else {
        setJobs([]);
      }
    } else {
      setJobs([]);
    }
  }, [timelineData, bookingSearch, taskStatusFilter, timelineDate]);

  const handleSelect = (selectedIndex, event) => {
    // Stop the event from bubbling up to handleColumnClick
    event.stopPropagation();

    setActiveSlide(selectedIndex);
  };

  useEffect(() => {
    const isTouchScreenDevice = () => {
      try {
        document.createEvent('TouchEvent');
        return true;
      } catch (e) {
        return false;
      }
    }

    setTouchScreen(isTouchScreenDevice());
  }, []);

  // filter tasks list by it's status 
  const filterTasks = (tasks) => {
    let tempTasks = [...tasks];
    if (!taskStatusFilter || taskStatusFilter === "all") return tempTasks;
    switch (taskStatusFilter) {
      case "assigned":
        return tempTasks = tempTasks?.filter((task) => task?.active !== true && task?.completed !== true && task?.cancelled !== true && task?.stopped !== true);
      case "active":
        return tempTasks = tempTasks?.filter((task) => task?.active === true);
      case "complete":
        return tempTasks = tempTasks?.filter((task) => task?.completed === true);
      case "cancelled":
        return tempTasks = tempTasks?.filter((task) => task?.cancelled === true);
      case "stopped":
        return tempTasks = tempTasks?.filter((task) => task?.stopped === true);
      default:
        return tempTasks;
    }
  }

  return (
    Array.isFullArray(jobs) &&
    <div className="carousel-wrapper">
      <Carousel
        activeIndex={activeSlide}
        onSelect={(selectedIndex, event) => handleSelect(selectedIndex, event)}
        interval={null}
        controls={!touchScreen}

      >
        {jobs.map((job, index) => (
          <Carousel.Item key={index}>

            <JobCard
              job={job}
              index={index}
              disabled={props?.disabled}

            />

          </Carousel.Item>

        ))}
      </Carousel>
    </div>
  );
};

export default JobList;
